/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Wizard application components
import FormField from "layouts/applications/wizard/components/FormField";
import { blueGrey } from "@mui/material/colors";

function Investments() {

  function Header(props) {
    return (
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox>
          <MDTypography variant="h3" fontWeight="heavy">
            {props.title}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  }

  return (
    <MDBox>
      <MDBox width="80%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            Information relayed regarding Qualified Investments.
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          This information was submitted by the applicant.
        </MDTypography>
      </MDBox>
      <MDBox mt={2}>
        <Card style={{padding: "15px"}}>
          <Header title={"Company Investments"}/>
          <Grid container spacing={3} justifyContent>
            <Divider sx={{ margin: 2 }} />
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Company Name
              </MDTypography>
                Abbott Labs
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Year of Investment
              </MDTypography>
                2021
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Amount of Investment
              </MDTypography>
                $150,000
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Type of Investment
              </MDTypography>
                Cash
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Company Address
              </MDTypography>
                845 Milligan Road
                Idaho Falls, ID 83402
            </Grid>
            </Grid>
          <Divider sx={{ margin: 2 }} />
          <Grid container spacing={3} justifyContent>
            <Divider sx={{ margin: 2 }} />
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Company Name
              </MDTypography>
                Homeward Bound Inc.
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Year of Investment
              </MDTypography>
                2022
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Amount of Investment
              </MDTypography>
                $50,000
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Type of Investment
              </MDTypography>
                Cash
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Company Address
              </MDTypography>
                2855 Walnut Street
                Denver, CO 80205
            </Grid>
          </Grid>
        </Card>
      </MDBox>

      <MDBox mt={2}>
        <Card style={{padding: "15px"}}>
          <Header title={"Organization Investments "}/>
          <p>(including Accelerators, VC Firms, etc.)</p>
          <Grid container spacing={3} justifyContent>
            <Divider sx={{ margin: 2 }} />
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Investor Name
              </MDTypography>
                Unshackled Ventures
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Year of Investment
              </MDTypography>
                2021
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Amount of Investment
              </MDTypography>
                $20,000
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Type of Investment
              </MDTypography>
                Cash
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Company Address
              </MDTypography>
                845 Milligan Road
                Idaho Falls, ID 83402 
            </Grid>
            </Grid>
          <Divider sx={{ margin: 2 }} />
          <Grid container spacing={3} justifyContent>
            <Divider sx={{ margin: 2 }} />
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Investor Name
              </MDTypography>
                TechStars
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Year of Investment
              </MDTypography>
                2022
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Amount of Investment
              </MDTypography>
                $10,000
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Type of Investment
              </MDTypography>
                Cash
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Company Address
              </MDTypography>
                2855 Walnut Street
                Denver, CO 80205
            </Grid>
          </Grid>
        </Card>
      </MDBox>


      <MDBox mt={2}>
        <Card style={{padding: "15px"}}>
        <Header title={"Government Grants or Awards"}/>
          <Grid container spacing={3} justifyContent>
            <Divider sx={{ margin: 2 }} />
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Government Entity
              </MDTypography>
                NASA
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Name of Approving Official
              </MDTypography>
                Neil Armstrong
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Amount of Investment
              </MDTypography>
                $20,000
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Company Address
              </MDTypography>
                7202 East Adamo Dr
                Tampa, FL 33619 
            </Grid>
          </Grid>
          <Divider sx={{ margin: 2 }} />
          <Grid container spacing={3} justifyContent>
            <Divider sx={{ margin: 2 }} />
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Government Entity
              </MDTypography>
                National Science Foundation
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Name of Approving Official
              </MDTypography>
                Bill Nye
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Amount of Award
              </MDTypography>
                $10,000
            </Grid>
            <Grid item xs={12} md={3}>
              <MDTypography variant="body2" color="text">
                Address
              </MDTypography>
                3755 Government Boulevard
                Mobile, AL 36693
            </Grid>
          </Grid>
        </Card>
      </MDBox>
    </MDBox>
  );
}

export default Investments;
